var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useGetModuleFieldsBuilderQuery, } from "@/store/api";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import EditField from "./edit";
import { useTranslation } from "react-i18next";
export default function Fields() {
    var _this = this;
    var _a = useParams(), packagesName = _a.packagesName, moduleName = _a.moduleName, type = _a.type, menu = _a.menu, fieldName = _a.fieldName;
    var t = useTranslation(["ModuleBuilder"]).t;
    var _b = useState(), fieldDefs = _b[0], setFieldDefs = _b[1];
    var _c = useGetModuleFieldsBuilderQuery({
        params: {
            package: "",
            module: moduleName,
            lang: "en_us",
        },
    }), listFieldDefs = _c.data, error = _c.error, isLoading = _c.isLoading, isFetching = _c.isFetching, refetch = _c.refetch;
    useEffect(function () {
        if (listFieldDefs) {
            setFieldDefs(listFieldDefs.data.fieldsData);
        }
    }, [listFieldDefs]);
    var handleFieldAction = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, refetch()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var mbRoot = "/modules/ModuleBuilder";
    var onClickEdition = function () {
        navigate("".concat(mbRoot, "/").concat(type, "/packages/").concat(packagesName, "/").concat(moduleName, "/languages"));
    };
    var navigate = useNavigate();
    var addField = function () {
        navigate("".concat(mbRoot, "/studio/packages/").concat(packagesName, "/").concat(moduleName, "/fields/new"));
    };
    var Content = function () {
        return (_jsxs("div", __assign({ className: "text-sm" }, { children: [_jsxs("div", __assign({ className: "m-1" }, { children: [_jsx("button", __assign({ onClick: addField, className: "button primary" }, { children: t("LBL_BTN_ADDFIELD") })), _jsx("button", __assign({ onClick: onClickEdition, className: "button secondary" }, { children: t("LBL_BTN_EDLABELS") }))] })), _jsx("div", __assign({ className: "table-container max-h-[40vh] overflow-y-scroll" }, { children: _jsxs("table", __assign({ className: "w-full border-collapse" }, { children: [_jsx("thead", { children: _jsxs("tr", __assign({ className: "border-gray-300 p-2 text-left border-b-2" }, { children: [_jsx("th", { children: t("LBL_NAME") }), _jsx("th", { children: t("LBL_DROPDOWN_ITEM_LABEL") }), _jsx("th", { children: t("LBL_DATA_TYPE") })] })) }), _jsx("tbody", { children: fieldDefs &&
                                    (fieldDefs === null || fieldDefs === void 0 ? void 0 : fieldDefs.map(function (field, index) { return (_jsxs("tr", __assign({ className: "border border-gray-300 p-2 text-left" }, { children: [_jsxs("td", { children: [field.custom && (_jsx("span", __assign({ className: "is-size-6 has-text-danger" }, { children: "*" }))), _jsx(Link, __assign({ to: "".concat(mbRoot, "/").concat(type, "/packages/").concat(packagesName, "/").concat(moduleName, "/").concat(menu, "/").concat(field.name), className: "text-[rbg(var(--color-blue-800))] hover:text-[rgb(var(--color-gray-600))]" }, { children: field.name }))] }), _jsx("td", { children: field.label }), _jsx("td", { children: field.type })] }), index)); })) })] })) }))] })));
    };
    return (_jsx(_Fragment, { children: fieldName ? (_jsx(EditField, { onFieldAction: handleFieldAction })) : (_jsx(Content, {})) }));
}
